import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ProfilePage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false } = props;
  const textClass = showAsIngress ? css.ingress : css.text;

  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  // Simple regex to check if the text is likely a phone number
  // It looks for a string that starts with + or a digit and contains mostly numbers
  const isPhoneNumber = text && /^\+?[0-9\s\-()]{7,20}$/.test(text.trim());

  const renderedContent = isPhoneNumber ? (
    <a href={`tel:${text.replace(/\s/g, '')}`} className={css.phoneLink}>
      {content}
    </a>
  ) : (
    content
  );

  return text ? (
    <div className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {heading}
        </Heading>
      ) : null}
      <p className={textClass}>{renderedContent}</p>
    </div>
  ) : null;
};

export default SectionTextMaybe;
